import React from 'react';
import ImportModal from '../common/ImportModal';
import { useTranslation } from 'react-i18next';

const ProductImportModal = ({
  isOpen,
  onClose,
  onImport,
  importing = false,
  importError = null,
  importSuccess = false,
}) => {
  const { t } = useTranslation();

  // Per-column guidance for the template's "Instructions" sheet. Keyed by the
  // exact header labels used in the catalogue import template.
  const NOTES = t('importTemplate.notes', { returnObjects: true });
  // Column names must match what product_catalogue.py's importer reads verbatim
  // (snake_case). Price moved to the SKU (product_size) in migration 061, so the
  // catalogue importer no longer reads a price column.
  const TEMPLATE_HEADERS = [
    'product_name',
    'product_category_name',
    'hsn_code',
    'description',
  ];

  const TEMPLATE_COLUMN_SPECS = {
    product_name: { required: true, example: 'GP Coils' },
    product_category_name: { required: true, note: NOTES.matchCategory, example: 'GP' },
    hsn_code: { required: true, example: '72104900' },
    description: { required: false, example: 'Galvanised coils' },
  };

  const importConfig = t('productCatalogue.import.config', { returnObjects: true });

  return (
    <ImportModal
      isOpen={isOpen}
      onClose={onClose}
      onImport={onImport}
      importing={importing}
      importError={importError}
      importSuccess={importSuccess}
      templateHeaders={TEMPLATE_HEADERS}
      templateColumnSpecs={TEMPLATE_COLUMN_SPECS}
      templateFilename={importConfig.templateFilename}
      inputId={importConfig.inputId}
      skipHeaderValidation={true}
    />
  );
};

export default ProductImportModal;